import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer, Header, Title } from '@calendly/ui/components/popup'

import { Message } from './styles'

export const BlockExpiredModal = ({ onClose, inviteeName, isPast }) => {
  const title = I18n.t('publisher.block_invitee.expired_modal.title', { name: inviteeName })

  const message = isPast
    ? I18n.t('publisher.block_invitee.expired_modal.message_attendee')
    : I18n.t('publisher.block_invitee.expired_modal.message_invitee')

  return (
    <Popup onClose={onClose}>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Body>
        <Message>{message}</Message>
      </Body>
      <Footer>
        <Button
          wide
          decoration="primary"
          onClick={onClose}
        >
          {I18n.t('publisher.block_invitee.expired_modal.confirm')}
        </Button>
      </Footer>
    </Popup>
  )
}
